import { AxiosResponse } from 'axios';
import { useMutation } from 'react-query';

import { api } from '../../http';
import { DefaultRes } from '../../types';

export function useGenericMutation<Params, ResultWithoutDefaultRes>(
    queryName: string, 
    urlToHit: string,
    method: 'post' | 'put' = 'post'
) {
    const makeGenericMutation = async (params: Params) => {
        const caller = method === 'post' ? api.post : api.put;

        const { data } = await caller<
            DefaultRes<ResultWithoutDefaultRes>,
            AxiosResponse<DefaultRes<ResultWithoutDefaultRes>>
        >(`/${urlToHit}`, {
            ...params,
        });

        return data;
    };

    return useMutation([queryName, urlToHit], makeGenericMutation);
}
